/* eslint-disable */
/* adapted original so that elements that 'animateOut' don't dissapear */
// removed viewport offset on page top (still there on page bottom)

Object.defineProperty(exports, '__esModule', { value: true });

const _createClass = (function() {
  function defineProperties(target, props) {
    for (let i = 0; i < props.length; i++) {
      const descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}());

const _get = function get(_x, _x2, _x3) {
  let _again = true;
  while (_again) {
    let object = _x,
      property = _x2,
      receiver = _x3;
    _again = false;
    if (object === null) object = Function.prototype;
    let desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
      let parent = Object.getPrototypeOf(object);
      if (parent === null) {
        return undefined;
      }
      _x = parent;
      _x2 = property;
      _x3 = receiver;
      _again = true;
      desc = parent = undefined;
      continue;
    } else if ('value' in desc) {
      return desc.value;
    } else {
      const getter = desc.get;
      if (getter === undefined) {
        return undefined;
      }
      return getter.call(receiver);
    }
  }
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError(
      `Super expression must either be null or a function, not ${typeof superClass}`,
    );
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass,
    enumerable: false,
    writable: true,
    configurable: true } });
  if (superClass) {
    Object.setPrototypeOf
      ? Object.setPrototypeOf(subClass, superClass)
      : (subClass.__proto__ = superClass);
  }
}

const _react = require('react');

const _react2 = _interopRequireDefault(_react);

const _lodashThrottle = require('lodash.throttle');

const _lodashThrottle2 = _interopRequireDefault(_lodashThrottle);

const _propTypes = require('prop-types');

const _propTypes2 = _interopRequireDefault(_propTypes);

const ScrollAnimation = (function(_Component) {
  _inherits(ScrollAnimation, _Component);

  function ScrollAnimation(props) {
    _classCallCheck(this, ScrollAnimation);

    _get(
      Object.getPrototypeOf(ScrollAnimation.prototype),
      'constructor',
      this,
    ).call(this, props);
    this.serverSide = typeof window === 'undefined';
    this.listener = (0, _lodashThrottle2.default)(
      this.handleScroll.bind(this),
      50,
    );
    this.visibility = { onScreen: false,
      inViewport: false };

    this.state = { classes: 'animated',
      style: { animationDuration: `${this.props.duration}s`,
        opacity: this.props.initiallyVisible ? 1 : 0 } };
  }

  _createClass(ScrollAnimation, [
    { key: 'getElementTop',
      value: function getElementTop(elm) {
        let yPos = 0;
        while (
          elm
          && elm.offsetTop !== undefined
          && elm.clientTop !== undefined
        ) {
          yPos += elm.offsetTop + elm.clientTop;
          elm = elm.offsetParent;
        }
        return yPos;
      } },
    { key: 'getScrollPos',
      value: function getScrollPos() {
        if (this.scrollableParent.pageYOffset !== undefined) {
          return this.scrollableParent.pageYOffset;
        }
        return this.scrollableParent.scrollTop;
      } },
    { key: 'getScrollableParentHeight',
      value: function getScrollableParentHeight() {
        if (this.scrollableParent.innerHeight !== undefined) {
          return this.scrollableParent.innerHeight;
        }
        return this.scrollableParent.clientHeight;
      } },
    { key: 'getViewportTop',
      value: function getViewportTop() {
        return this.getScrollPos() // + this.props.offset;
      } },
    { key: 'getViewportBottom',
      value: function getViewportBottom() {
        return (
          this.getScrollPos()
          + this.getScrollableParentHeight()
          - this.props.offset
        );
      } },
    { key: 'isInViewport',
      value: function isInViewport(y) {
        return y >= this.getViewportTop() && y <= this.getViewportBottom();
      } },
    { key: 'isAboveViewport',
      value: function isAboveViewport(y) {
        return y < this.getViewportTop();
      } },
    { key: 'isBelowViewport',
      value: function isBelowViewport(y) {
        return y > this.getViewportBottom();
      } },
    { key: 'inViewport',
      value: function inViewport(elementTop, elementBottom) {
        return (
          this.isInViewport(elementTop)
          || this.isInViewport(elementBottom)
          || (this.isAboveViewport(elementTop)
            && this.isBelowViewport(elementBottom))
        );
      } },
    { key: 'onScreen',
      value: function onScreen(elementTop, elementBottom) {
        return (
          !this.isAboveScreen(elementBottom) && !this.isBelowScreen(elementTop)
        );
      } },
    { key: 'isAboveScreen',
      value: function isAboveScreen(y) {
        return y < this.getScrollPos();
      } },
    { key: 'isBelowScreen',
      value: function isBelowScreen(y) {
        return y > this.getScrollPos() + this.getScrollableParentHeight();
      } },
    { key: 'getVisibility',
      value: function getVisibility() {
        const elementTop = this.getElementTop(this.node)
          - this.getElementTop(this.scrollableParent);
        const elementBottom = elementTop + this.node.clientHeight;
        return { inViewport: this.inViewport(elementTop, elementBottom),
          onScreen: this.onScreen(elementTop, elementBottom) };
      } },
    { key: 'componentDidMount',
      value: function componentDidMount() {
        if (!this.serverSide) {
          const parentSelector = this.props.scrollableParentSelector;
          this.scrollableParent = parentSelector
            ? document.querySelector(parentSelector)
            : window;
          if (this.scrollableParent && this.scrollableParent.addEventListener) {
            this.scrollableParent.addEventListener('scroll', this.listener);
          } else {
            console.warn(
              `Cannot find element by locator: ${
                this.props.scrollableParentSelector
              }`,
            );
          }
          if (this.props.animatePreScroll) {
            this.handleScroll();
          }
        }
      } },
    { key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        clearTimeout(this.delayedAnimationTimeout);
        clearTimeout(this.callbackTimeout);
        if (window && window.removeEventListener) {
          window.removeEventListener('scroll', this.listener);
        }
      } },
    { key: 'visibilityHasChanged',
      value: function visibilityHasChanged(previousVis, currentVis) {
        return (
          previousVis.inViewport !== currentVis.inViewport
          || previousVis.onScreen !== currentVis.onScreen
        );
      } },
    { key: 'animate',
      value: function animate(animation, callback) {
        const _this = this;

        this.delayedAnimationTimeout = setTimeout(() => {
          _this.animating = true;
          _this.setState({ classes: `animated ${animation}`,
            style: { animationDuration: `${_this.props.duration}s` } });
          _this.callbackTimeout = setTimeout(
            callback,
            _this.props.duration * 1000,
          );
        }, this.props.delay);
      } },
    { key: 'animateIn',
      value: function animateIn(callback) {
        const _this2 = this;

        this.animate(this.props.animateIn, () => {
          if (!_this2.props.animateOnce) {
            _this2.setState({ style: { animationDuration: `${_this2.props.duration}s`,
              opacity: 1 } });
            _this2.animating = false;
          }
          const vis = _this2.getVisibility();
          if (callback) {
            callback(vis);
          }
        });
      } },
    { key: 'animateOut',
      value: function animateOut(callback) {
        const _this3 = this;

        this.animate(this.props.animateOut, () => {
          _this3.setState({
            //               classes: "animated",
            style: { animationDuration: `${_this3.props.duration}s`,
              opacity: 1 } });
          const vis = _this3.getVisibility();

          if (callback) {
            callback(vis);
          }
        });
      } },
    { key: 'handleScroll',
      value: function handleScroll() {
        if (!this.animating) {
          const currentVis = this.getVisibility();
          if (this.visibilityHasChanged(this.visibility, currentVis)) {
            clearTimeout(this.delayedAnimationTimeout);
            if (!currentVis.onScreen) {
              this.setState({ classes: 'animated',
                style: { animationDuration: `${this.props.duration}s`,
                  opacity: this.props.initiallyVisible ? 1 : 0 } });
            } else if (currentVis.inViewport && this.props.animateIn) {
              this.animateIn(this.props.afterAnimatedIn);
            } else if (
              currentVis.onScreen
              && this.visibility.inViewport
              && this.props.animateOut
              && this.state.style.opacity === 1
            ) {
              this.animateOut(this.props.afterAnimatedOut);
            }
            this.visibility = currentVis;
          }
        }
      } },
    { key: 'render',
      value: function render() {
        const _this4 = this;

        const classes = this.props.className
          ? `${this.props.className} ${this.state.classes}`
          : this.state.classes;
        return _react2.default.createElement(
          'div',
          { ref(node) {
            _this4.node = node;
          },
          className: classes,
          style: Object.assign({}, this.state.style, this.props.style) },
          this.props.children,
        );
      } },
  ]);

  return ScrollAnimation;
}(_react.Component));

exports.default = ScrollAnimation;

ScrollAnimation.defaultProps = { offset: 150,
  duration: 1,
  initiallyVisible: false,
  delay: 0,
  animateOnce: false,
  animatePreScroll: true };

ScrollAnimation.propTypes = { animateIn: _propTypes2.default.string,
  animateOut: _propTypes2.default.string,
  offset: _propTypes2.default.number,
  duration: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  initiallyVisible: _propTypes2.default.bool,
  animateOnce: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  scrollableParentSelector: _propTypes2.default.string,
  className: _propTypes2.default.string,
  animatePreScroll: _propTypes2.default.bool };
module.exports = exports.default;
